import Decimal from "decimal.js";
import { isNumber } from "./MathUtils";

const defaultScale = 7;
const logInfo = false;

export function sum(
  valueA: number,
  valueB: number,
  rules: { decimalPlaces?: number; roundingRule?: string } = {}
): number {
  valueA = Number(valueA);
  valueB = Number(valueB);

  let result = 0;
  if (isNumber(valueA) && isNumber(valueB)) {
    // let value = valueA + valueB;
    let value = new Decimal(valueA).plus(valueB).toDecimalPlaces(defaultScale);
    result = round(value, rules);
    if (logInfo)
      console.warn(
        `Soma dos valores ${valueA} e ${valueB} = ${value} = ${result}`
      );
  }
  return result;
}

export function subtract(
  valueA: number,
  valueB: number,
  rules: { decimalPlaces?: number; roundingRule?: string } = {}
): number {
  valueA = Number(valueA);
  valueB = Number(valueB);

  let result = 0;
  if (isNumber(valueA) && isNumber(valueB)) {
    // let value = valueA - valueB;
    let value = new Decimal(valueA).minus(valueB).toDecimalPlaces(defaultScale);
    result = round(value, rules);
    if (logInfo)
      console.warn(
        `Subtração dos valores ${valueA} e ${valueB} = ${value} = ${result}`
      );
  }
  return result;
}

export function times(
  valueA: number,
  valueB: number,
  rules: { decimalPlaces?: number; roundingRule?: string } = {}
): number {
  valueA = Number(valueA);
  valueB = Number(valueB);

  let result = 0;
  if (isNumber(valueA) && isNumber(valueB)) {
    // let value = valueA * valueB;
    let value = new Decimal(valueA).times(valueB).toDecimalPlaces(defaultScale);
    result = round(value, rules);
    if (logInfo)
      console.warn(
        `Multiplicação dos valores ${valueA} e ${valueB} = ${value} = ${result}`
      );
  }
  return result;
}

export function divide(
  valueA: number,
  valueB: number,
  rules: { decimalPlaces?: number; roundingRule?: string } = {}
): number {
  valueA = Number(valueA);
  valueB = Number(valueB);

  let result = 0;
  if (isNumber(valueA) && isNumber(valueB) && valueB !== 0) {
    // let value = valueA / valueB;
    let value = new Decimal(valueA)
      .dividedBy(valueB)
      .toDecimalPlaces(defaultScale);
    result = round(value, rules);
    if (logInfo)
      console.warn(
        `Divisão dos valores ${valueA} e ${valueB} = ${value} = ${result}`
      );
  }
  return result;
}

export function roundBy(
  value: number,
  rules: { decimalPlaces?: number; roundingRule?: string }
) {
  value = Number(value);
  if (!isNumber(value)) return 0;
  return round(new Decimal(value), rules);
}

function round(
  value: Decimal,
  {
    decimalPlaces = defaultScale,
    roundingRule = "round",
  }: { decimalPlaces?: number; roundingRule?: string }
) {
  if (roundingRule === "trunc") {
    const fixedValue = value.toFixed(decimalPlaces, Decimal.ROUND_DOWN);
    value = new Decimal(fixedValue);
  }
  return value.toDecimalPlaces(decimalPlaces).toNumber();
}



// WEBPACK FOOTER //
// ./src/utils/DecimalUtils.ts